import React, { useState } from "react";
import NavBar from "./NavBar";

import CUBackgroundImage from "./../images/contactus_background.jpg";
import CareerBackgroundImage from "./../images/nursing_background.jpeg";
import { useNavigate } from "react-router-dom";

const AboutLeadership = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="homeHeaderContainer leadershipHeaderContainer">
        <div>
          <h1 className="homeTitleText">Our Leadership</h1>
        </div>
        <div className="homeBodyText">
          <p>
            At iCare Village, our leadership team is responsible for setting the
            standards that guide every aspect of care we provide. With deep
            experience in healthcare, health informatics, and community-based
            support, our leaders are committed to delivering safe, reliable, and
            compassionate in-home care to older adults and their families.
          </p>
          <p>
            As a home care service provider, we take responsibility for the
            people who deliver care on our behalf. Our leadership oversees
            hiring, training, scheduling, and quality assurance to ensure that
            every caregiver reflects our values of respect, dignity, and
            professionalism.
          </p>
          <p>
            We believe that high-quality care starts with strong leadership and
            clear accountability. By supporting our care team and continuously
            improving our services, we aim to provide personalized, dependable
            care that allows seniors to live safely and confidently at home.
          </p>
          <p>
            Together, we work to strengthen the health, independence, and
            well-being of the communities we serve.
          </p>
        </div>
      </div>
      <div className="homeBodyContainer">
        <div className="leadershipTeam">
          <h2>Meet Our Leadership Team</h2>
          <div className="leadershipMemberFounder">
            <div className="leadershipFounder">
              <img
                src={require("./../images/Jonas_Pic.png")}
                alt="Leadership Member"
                className="leadershipMemberImg"
              />
              <h3>Dr. Jonas Bambi</h3>
              <h5>Founder</h5>
              <p>
                Dr. Jonas Bambi is the founder of iCare Village and brings over
                20 years of experience spanning healthcare services
                optimization, health informatics, information systems, and
                technology leadership. He holds a PhD in Health Informatics and
                has worked extensively with organizations such as Island Health
                and Northern Health, supporting the design and improvement of
                healthcare delivery systems.
              </p>
              <p>
                Inspired by a deep respect for older adults and a commitment to
                helping people age with dignity, Dr. Bambi founded iCare Village
                to provide reliable, high-quality in-home care supported by
                thoughtful use of technology. His leadership focuses on ensuring
                that care services are delivered safely, ethically, and
                consistently, with clear standards for hiring, training, and
                supervision of care staff
              </p>
              <p>
                Dr. Bambi’s approach combines evidence-informed decision-making
                with compassion and community values, guiding iCare Village in
                its mission to make aging at home safer, more connected, and
                more sustainable for seniors and their families.
              </p>
            </div>
          </div>
          <div className="leadershipMemberContainer">
            {/* <div className="leadershipMember">
              <img
                src={require("./../images/Maggie_Pic.png")}
                alt="Leadership Member"
                className="leadershipMemberImg"
              />
              <h3>Marguerite Kolie</h3>
              <h5>Director of Operations</h5>
              <p>
                As Director of Operations at iCare Village, Marguerite brings
                extensive experience in initiating, implementing, and managing
                community-based programs that improve lives and strengthen local
                support networks. With a deep understanding of grassroots
                service delivery and organizational leadership, combined with a
                hands-on approach, her goal is to ensures that iCare Village’s
                services are delivered with excellence, consistency, and heart.
              </p>
            </div> */}
            <div className="leadershipMember">
              <img
                src={require("./../images/Nancy_Pic.png")}
                alt="Leadership Member"
                className="leadershipMemberImg"
              />
              <h3>Nancy Yates</h3>
              <h5>Advisor</h5>
              <p>
                Nancy Yates serves as an advisor to iCare Village, bringing
                decades of nursing experience and lived insight as a senior
                herself. A retired nurse, Nancy offers invaluable perspective on
                the real-world needs, challenges, and expectations of older
                adults receiving care at home.
              </p>
              <p>
                Her guidance helps ensure that iCare Village’s services are
                grounded in dignity, safety, and respect, and that care
                practices remain person-centred rather than task-driven. Nancy
                contributes to shaping care standards, service design, and
                quality expectations, ensuring that policies and procedures
                reflect both clinical wisdom and human understanding.
              </p>
              <p>
                Through her advisory role, Nancy helps iCare Village maintain a
                strong focus on compassionate care that honors lived experience
                and supports aging with confidence and dignity.
              </p>
            </div>
            <div className="leadershipMember">
              <img
                src={require("./../images/Dang_Pic.png")}
                alt="Leadership Member"
                className="leadershipMemberImg"
              />
              <h3>Kha Hoang</h3>
              <h5>Technical Support Lead</h5>
              <p>
                Kha Hoang leads technical support at iCare Village and is
                responsible for maintaining the reliability, security, and
                day-to-day operation of the technology systems that support care
                delivery. His work ensures that scheduling, communication, and
                service coordination tools function smoothly for both clients
                and care staff.
              </p>
              <p>
                With a strong understanding of the platform architecture and a
                commitment to continuous improvement, Kha plays a key role in
                enabling efficient operations while minimizing disruption to
                care services. His focus is on stability, responsiveness, and
                usability – so care teams can concentrate on what matters most:
                supporting clients safely and effectively.
              </p>
              <p>
                Kha’s role helps bridge technology and care delivery,
                reinforcing iCare Village’s commitment to dependable service and
                operational accountability.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="AUMoreContainer">
        <div className="AUCareerTitle AUCareerBackground">
          <h1>Work With Us!</h1>
          <p>
            Ready to join our local team? Submit your resume to be considered
            for current and future opportunities.
          </p>
          <button
            className="AUCareerButton"
            onClick={() => {
              navigate("/careers");
            }}
          >
            Go to Careers
          </button>
        </div>
        <div className="AUCareerTitle AUContactUsBackground">
          <h1>Connect with us</h1>
          <p>
            We'd love to hear from you! Here are all the ways you can get in
            touch.
          </p>
          <button
            className="AUCareerButton "
            onClick={() => {
              navigate("/ContactUs");
            }}
          >
            Go to Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutLeadership;
